module.exports = __webpack_public_path__ + "img/bianzu2.9549ceeb.png";